// extracted by mini-css-extract-plugin
export default {"header":"BookmarkHeader_header__HyuJ3","arrow":"BookmarkHeader_arrow__ZK5Bl"};